import React from 'react';
import {BrowserRouter ,Route,Switch}from 'react-router-dom';
import './App.css';
import Login from './components/login/Login';
import ImportTabs from './components/importFiles/ImportTabs';
// import ImportJob from './components/importFiles/ImportJob';

function App() {
  return (
    <div >
      <BrowserRouter basename={'/cha_maa_uni_logistics_v1'}>
       <Switch >
         <Route exact path={'/'} component={Login} ></Route>
         <Route path={'/imports'} component={ImportTabs} ></Route>
         {/* <Route path={'/importsQuery'} component={ImportJob} ></Route> */}
       </Switch>
       </BrowserRouter>
    </div>
  );
}

export default App;
